import React from "react";
import styles from "./recommendationStyles";
import { withStyles } from "@material-ui/core/styles";
import Recommendation from "./Recommendation";
import { postData } from "../../../../../api/componentAPIs";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { Refresh } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import appConstants from "../../../../../appConstants";
import ManualDriverAssignment from "./ManualDriverAssignment";
import { sortBy } from "lodash";
import { observer, inject } from "mobx-react";

const dialogStyles = (theme) => ({
  root: {
    margin: 0,
    marginBottom: 12,
    padding: 8,
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 16,
    color: theme.iconColor,
  },
  refreshButton: {
    position: "absolute",
    right: 48,
    top: 16,
    color: theme.iconColor,
  },
  dialogTitle: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
});

const DialogTitle = withStyles(dialogStyles)((props) => {
  const {
    children,
    classes,
    onClose,
    handleChange,
    handleRefresh,
    hasDispatchedDrivers,
    ...other
  } = props;
  return (
    <div>
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography className={classes.dialogTitle}>{children}</Typography>
        <IconButton
          className={classes.refreshButton}
          onClick={handleRefresh}
          disabled={!hasDispatchedDrivers}
        >
          <Refresh />
        </IconButton>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleChange}
        >
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
    </div>
  );
});

@inject("DispatchStore")
@observer
class DriverRecommendations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      errorMsg: "",
      recommendationData: [],
    };
  }

  componentDidMount() {
    this.getData();
  }

  componentWillUnmount() {
    this.props.handleClose();
  }

  getData = () => {
    if (!this.props.DispatchStore.dispatchedDrivers.length) {
      this.setState({loading: false});
      return ;
    }
    const RequestData = {
      pickupId: this.props.pickupId,
      terminalCode: this.props.userData.userProfile.terminal.code,
    };
    postData("Recommendations", RequestData).then(
      (res) => {
        const recommendationData = this.getFormattedRecommendationData(
          res.data
        );

        this.setState({
          loading: false,
          recommendationData,
        });

        // select feasible recommended drivers in driver grid
        const driverIdList = this.getTopFeasibleRecommendedDrivers(
          recommendationData
        ).map((route) => route.driverId.toUpperCase());
        if (driverIdList.length) {
          this.props.glEventHub.emit("SelectDriverRoutes", driverIdList);
        }
      },
      (err) => {
        const backendError = err?.error?.message ?? "";
        const engineError = err?.data?.error?.detail?.message ?? "";
        this.setState({
          loading: false,
          errorMsg: backendError || engineError,
          recommendationData: [],
        });
      }
    );
  };

  getFormattedRecommendationData = (recommendationRoutes) => {
    const updatedRecommendationRoutes = recommendationRoutes.map((r) => {
      const matchedRoute = this.props.DispatchStore.routesList.find(
        (route) => route.routeId.toLowerCase() === r.routeId.toLowerCase()
      );
      const virtualStop = r.stops.find((stop) => stop.isVirtualStop);
      if (matchedRoute) {
        return {
          ...matchedRoute,
          trailerCapacity: virtualStop.estimatedTrailerSpaceRemaining,
          arrivalTime: virtualStop.estimatedTimeOfArrival,
          routeStops: matchedRoute.stops,
          ...r,
        };
      }
    });
    return sortBy(
      updatedRecommendationRoutes.filter(Boolean),
      "recommendationRank"
    );
  };

  handleRefresh = () => {
    this.setState({
      loading: true,
      errorMsg: "",
    });
    this.getData();
  };

  getTopFeasibleRecommendedDrivers = (recommendationData) => {
    /* return top 5 feasible recommended drivers */
    return recommendationData
      .filter((r) => r.isFeasibleOption)
      .slice(0, appConstants.MAX_FEASIBLE_DRIVERS);
  };

  renderRecommendationLabel = (feasibleDriverRecommendationCount) => {
    const { loading, errorMsg, recommendationData } = this.state;
    const { classes } = this.props;
    if (loading) {
      return null;
    }
    if (errorMsg) {
      return (
        <div className={classes.noRecommendations}>
          <h3>Driver Recommendations failed</h3>
          <span className={classes.error}>Error : {errorMsg}</span>
        </div>
      );
    } else if (!this.props.DispatchStore.dispatchedDrivers.length) {
      return (
        <h3 className={classes.noRecommendations}>
          No Active Drivers found
        </h3>
      );
    }
    else if (recommendationData.length === 0) {
      return (
        <h3 className={classes.noRecommendations}>
          No Recommendations available
        </h3>
      );
    } else if (!feasibleDriverRecommendationCount) {
      return (
        <h3 className={classes.noRecommendations}>
          No Feasible driver available
        </h3>
      );
    }
    return null;
  };

  render() {
    const { classes, pickupId } = this.props;
    const terminalOffset = this.props.DispatchStore.terminalOffset;
    const { loading, recommendationData } = this.state;
    const topFeasibleDriverRecommendations =
      this.getTopFeasibleRecommendedDrivers(recommendationData);

    return (
      <div className={classes.allRecommendationContainer}>
        <DialogTitle
          id="customized-dialog-title"
          handleChange={this.props.handleClose}
          handleRefresh={this.handleRefresh}
          hasDispatchedDrivers = {this.props.DispatchStore.dispatchedDrivers.length}
        >
          Driver Recommendations
        </DialogTitle>
        {loading && <CircularProgress size={24} className={classes.loader} />}
        <div
          className={`${classes.innerAllRecommendationContainer} customScroll`}
        >
          {!loading &&
            topFeasibleDriverRecommendations.map((d) => (
              <Recommendation
                key={`Recommendation Route_${d.routeId} `}
                data={d}
                onClick={() => this.props.assignPickup(d.driverId, pickupId)}
                terminalOffset={terminalOffset}
              />
            ))}
          {this.renderRecommendationLabel(
            topFeasibleDriverRecommendations.length
          )}
          {!loading && recommendationData.length > 0 && (
            <ManualDriverAssignment
              assignPickup={this.props.assignPickup}
              pickupId={pickupId}
              recommendationData={recommendationData}
              terminalOffset={terminalOffset}
              dispatchedDrivers={this.props.DispatchStore.dispatchedDrivers}
              glEventHub={this.props.glEventHub}
            />
          )}
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withUserProfile
)(DriverRecommendations);
